export function assertNonEmpty(value) {
    if (!value) {
        throw new Error('Value should be fulfilled');
    }
    return value;
}
//# sourceMappingURL=assertNonEmpty.js.map